import forEach from "lodash/forEach";
import { ActionStore } from "higher-order/ActionStore";

export default class PropsStore extends ActionStore {
    constructor(props, dispatcher) {
        super(dispatcher);
        forEach(props, (value, key) => {
            this[key] = value;
        });
    }
}
